'use client'
import dynamic from 'next/dynamic'
import WithSuspense from '../WithSuspense'
export const QuickLinksPortal = WithSuspense(dynamic(() => import('./QuickLinksPortal'), { ssr: false }))
export const QuickLinks = WithSuspense(dynamic(() => import('./QuickLinks'), { ssr: false }))
export { Links } from './QuickLinks'
